(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_media-without-appearance"] && !Shopify.designMode) return;
  try {
    // Enforce "no controls" even if other theme scripts mutate the video element.
  document.addEventListener('DOMContentLoaded', function () {
    var v = document.querySelector('.video-bg video');
    if (!v) return;

    function strip() {
      if (v.hasAttribute('controls')) v.removeAttribute('controls');
      if (v.controls) v.controls = false;
      if (!v.hasAttribute('disablepictureinpicture')) v.setAttribute('disablepictureinpicture','');
      if (!v.hasAttribute('controlslist')) v.setAttribute('controlslist','nodownload noplaybackrate noremoteplayback');
    }
    strip();

    // Watch for attributes being toggled by other scripts
    var mo = new MutationObserver(strip);
    mo.observe(v, { attributes: true, attributeFilter: ['controls', 'controlslist'] });

    // Re-strip during common media lifecycle events
    ['loadedmetadata','loadeddata','play','pause','enterpictureinpicture','webkitbeginfullscreen']
      .forEach(function(evt){ v.addEventListener(evt, strip, { passive: true }); });
  });

  // If your theme uses section rendering / PJAX, reapply on those events too
  document.addEventListener('shopify:section:load', function(){ 
    var v = document.querySelector('.video-bg video'); 
    if (!v) return;
    if (v.hasAttribute('controls')) v.removeAttribute('controls');
    v.controls = false;
  });
  } catch(e) { console.error(e); }
})();

})();
